module.exports = __webpack_public_path__ + "img/emoji-smile-fill.d8d7b300.svg";